import { TranslationsContext } from '@teliaee/telia-translate';
import { AnalyticsTrigger, Button, Card, CardContent, GridColumn, Heading, ITagProps, Separator, Text } from 'telia-front-react';
import * as React from 'react';
import { Segment } from '../../stores/SegmentStore';
import { renderCurrency } from '../../util/PriceUtil';
import PackageOrderingModal from './PackageOrderingModal';
import { twebTranslateOrEmpty } from '../../util/TranslateUtil';
import { Country, Package } from '../RoamingInterfaces';
import { getPackagePriceForSegment } from '../../util/RoamingPackagesUtil';

interface RoamingPackageCardProps {
  roamingPackage: Package;
  selectedCountry: Country;
  segment: Segment;
  packageTag: ITagProps;
  packageTermsLink: string;
  showOrderingModal: boolean;
}

const RoamingPackageCard = (props: RoamingPackageCardProps): JSX.Element => {
  const { roamingPackage, selectedCountry, packageTag, packageTermsLink, segment, showOrderingModal } = props;
  const { translate, translateOrEmpty } = React.useContext(TranslationsContext);
  const conditionsAnalyticsId = `Link - ${selectedCountry.isoCode} - ${roamingPackage.estKeywords[0]} ${roamingPackage.volume} - Tingimused`;

  const roamingPackagePrice = getPackagePriceForSegment(roamingPackage, segment);

  return (
    <GridColumn width={['sm-6', 'lg-4', 'xl-3']}>
      <Card padding="medium" background="brand-secondary-bg-subtlest" tag={packageTag}>
        <CardContent>
          <Text>
            <p>{translate(`roaming.country.package.name.${roamingPackage.serviceShortName}`)}</p>
            <Separator spacing="xxsmall" color="invisible" />
            <Heading element="h3" className="text__margin-none">
              {translate(`roaming.country.package.volume.${roamingPackage.volume}`)}
            </Heading>
            <Separator spacing="small" weight="thin" />
            <Heading element="h4">{`${roamingPackagePrice} ${renderCurrency(segment !== 'BUSINESS', roamingPackagePrice !== '0', translate, '€')}`}</Heading>
            <p className="text-light text-small">
              {twebTranslateOrEmpty(translateOrEmpty, `roaming.country.package.description.${roamingPackage.serviceShortName}`)}
            </p>
            <AnalyticsTrigger trigger={{ id: conditionsAnalyticsId, callback: 'onClick' }}>
              <Button text={translate('roaming.country.package.day.show-terms')} link={true} target="_blank" iconLeft="#file-pdf" url={packageTermsLink} />
            </AnalyticsTrigger>
            {showOrderingModal && (
              <>
                <Separator spacing="small" color="invisible" />
                <PackageOrderingModal segment={segment} roamingPackage={roamingPackage} selectedCountry={selectedCountry} />
              </>
            )}
          </Text>
        </CardContent>
      </Card>
    </GridColumn>
  );
};

export default RoamingPackageCard;
